define.alias("shared/components/shared/ui/report/settings-wrapper", "settings/components/shared/ui/report/settings-wrapper");